import { useState } from 'react';

import { t } from '../hooks/useT';

import { useAuth } from '../hooks/useAuth';

import { NOTIFY_HOUR_OPTIONS, usePushNotifications } from '../hooks/usePushNotifications';



interface Props {

  onClose: () => void;

}



export function NotificationOnboardingModal({ onClose }: Props) {

  const { updateNotificationPrefs } = useAuth();

  const push = usePushNotifications();

  const [emailEnabled, setEmailEnabled] = useState(false);

  const [pushEnabled, setPushEnabled] = useState(false);

  const [notifyTime, setNotifyTime] = useState('08:00');

  const [busy, setBusy] = useState(false);

  const [error, setError] = useState('');



  const dismissLater = async () => {

    setBusy(true);

    setError('');

    try {

      await updateNotificationPrefs({ notifyPromptSeen: true });

      onClose();

    } catch {

      setError(t('notifications.saveError'));

    } finally {

      setBusy(false);

    }

  };



  const saveChoices = async () => {

    setBusy(true);

    setError('');

    try {

      let pushActive = false;

      if (pushEnabled && push.support !== 'unsupported') {

        try {

          await push.subscribe();

          pushActive = true;

        } catch (err) {

          const code = (err as Error).message;

          if (code === 'permission_denied') {

            setError(t('notifications.pushDenied'));

          } else if (code === 'push_not_configured') {

            setError(t('notifications.pushUnavailable'));

          } else {

            setError(t('notifications.pushError'));

          }

          if (!emailEnabled) {

            setBusy(false);

            return;

          }

        }

      }



      await updateNotificationPrefs({

        notifyEmailEnabled: emailEnabled,

        notifyPushEnabled: pushActive,

        notifyTime: emailEnabled || pushActive ? notifyTime : undefined,

        notifyPromptSeen: true,

      });

      onClose();

    } catch {

      setError(t('notifications.saveError'));

    } finally {

      setBusy(false);

    }

  };



  return (

    <div className="admin-crop-overlay" role="dialog" aria-modal="true">

      <div className="notification-onboarding-modal">

        <header className="admin-crop-head">

          <h2>{t('notifications.onboardingTitle')}</h2>

        </header>

        <p className="admin-crop-hint">{t('notifications.onboardingHint')}</p>



        <label className="notification-toggle">

          <input

            type="checkbox"

            checked={emailEnabled}

            onChange={(e) => setEmailEnabled(e.target.checked)}

          />

          <span>{t('notifications.channelEmail')}</span>

        </label>



        <label className={`notification-toggle${push.support === 'unsupported' ? ' is-disabled' : ''}`}>

          <input

            type="checkbox"

            checked={pushEnabled}

            disabled={push.support === 'unsupported'}

            onChange={(e) => setPushEnabled(e.target.checked)}

          />

          <span>{t('notifications.channelPush')}</span>

        </label>

        {push.support === 'unsupported' && (

          <p className="notification-note muted">{t('notifications.pushUnsupported')}</p>

        )}



        {(emailEnabled || pushEnabled) && (

          <>

            <label className="notification-time-field">

              <span>{t('notifications.timeLabel')}</span>

              <select value={notifyTime} onChange={(e) => setNotifyTime(e.target.value)}>

                {NOTIFY_HOUR_OPTIONS.map((hour) => (

                  <option key={hour} value={hour}>{hour}</option>

                ))}

              </select>

            </label>

            <p className="notification-note muted">{t('notifications.timezoneHint')}</p>

          </>

        )}



        {error && <p className="admin-msg admin-msg-error">{error}</p>}



        <div className="notification-onboarding-actions">

          <button type="button" className="btn primary" disabled={busy} onClick={() => void dismissLater()}>

            {busy ? t('common.loading') : t('notifications.onboardingLater')}

          </button>

          <button type="button" className="btn secondary" disabled={busy} onClick={() => void saveChoices()}>

            {t('notifications.onboardingSave')}

          </button>

        </div>

      </div>

    </div>

  );

}


